import { render, staticRenderFns } from "./verification-reset-password.vue?vue&type=template&id=b835fede&"
import script from "./verification-reset-password.vue?vue&type=script&lang=js&"
export * from "./verification-reset-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports